import { Component } from 'react';

class CaptionDisplay extends Component<any> {
  renderCaptions() {
    return this.props.captions.map((caption, index) => {
      return (
        <h3
          key={index}
          className={
            this.props.showAll || index === this.props.captions.length - 1
              ? 'visible'
              : ''
          }
        >
          {caption}
        </h3>
      );
    });
  }

  getContainerClassName() {
    let className = 'caption-display ';

    className += this.props.characterType + ' ';
    className += this.props.characterCase + ' ';
    className = this.props.offsetClassName
      ? className + this.props.offsetClassName
      : className;

    return className;
  }

  render() {
    return (
      <div
        className={this.getContainerClassName()}
        style={{ fontSize: `${15 + (this.props.textSize - 100) / 10}px` }}
      >
        {this.renderCaptions()}
      </div>
    );
  }
}

export default CaptionDisplay;
